import { FC } from 'react'
import { Modal } from 'react-bootstrap'

type TableCombination = {
  tableIds: number[]
  tableNumbers: string[]
  totalCapacity: number
  wastePercentage: number
  allocationMethod: string
}

type SuggestionData = {
  hasAvailableTables: boolean
  suggestions: TableCombination[]
  environment: {
    id: number
    name: string
  }
  booking: {
    id: number
    name: string
    people: number
    hour: string
    date: string
  }
}

type TableSuggestionModalProps = {
  show: boolean
  onClose: () => void
  onAccept: (suggestion: TableCombination) => void
  onConfirmWithoutTable?: () => Promise<void>
  suggestions: SuggestionData | null
}

export const TableSuggestionModal: FC<TableSuggestionModalProps> = ({
  show,
  onClose,
  onAccept,
  onConfirmWithoutTable,
  suggestions,
}) => {
  if (!suggestions) return null

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Sugestão de Alocação de Mesa</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          <h6>
            Reserva: <strong>{suggestions.booking.name}</strong>
          </h6>
          <p className="mb-2">
            <strong>Pessoas:</strong> {suggestions.booking.people} |{' '}
            <strong>Horário:</strong> {suggestions.booking.hour}
          </p>
          <p className="mb-0">
            <strong>Ambiente:</strong> {suggestions.environment.name}
          </p>
        </div>

        {suggestions.hasAvailableTables ? (
          <>
            <h6 className="mb-3">Selecione uma opção de mesa:</h6>
            {suggestions.suggestions.map((suggestion, index) => (
              <div key={index} className="card mb-3">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <h6 className="mb-2">Opção {index + 1}</h6>
                      <p className="mb-1">
                        <strong>Mesas:</strong> {suggestion.tableNumbers.join(', ')}
                      </p>
                      <p className="mb-1">
                        <strong>Capacidade:</strong> {suggestion.totalCapacity} lugares
                      </p>
                      <p className="mb-0">
                        <strong>Desperdício:</strong>{' '}
                        <span
                          style={{
                            color:
                              suggestion.wastePercentage <= 20
                                ? '#28a745'
                                : suggestion.wastePercentage <= 40
                                ? '#ffc107'
                                : '#dc3545',
                          }}
                        >
                          {suggestion.wastePercentage}%
                        </span>
                      </p>
                    </div>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        console.log('🔘 Botão Selecionar clicado', suggestion)
                        onAccept(suggestion)
                      }}
                    >
                      Selecionar
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="alert alert-warning" role="alert">
            Não há mesas disponíveis no momento para esta reserva.
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button 
          className="btn btn-info" 
          onClick={async () => {
            console.log('🎯 Botão "Recusar e confirmar sem mesa" clicado')
            if (onConfirmWithoutTable) {
              await onConfirmWithoutTable()
            }
            onClose()
          }}
        >
          {suggestions.hasAvailableTables
            ? 'Recusar e confirmar sem mesa'
            : 'Confirmar sem mesa'}
        </button>
      </Modal.Footer>
    </Modal>
  )
}
